<template>
  <div>
    <a-row :gutter="[10, 10]">
      <a-col :md="24" :sm="8">
        <a-card :title="$t('dashboard.order.darcodeData')">
          <a-card-grid
              v-for="(item, index) in orderInfo"
              :key="index"
              style="width:25%;height:92px;overflow:overlay;text-align:center"
          >
            <div>{{ item.label }}</div>
            <div>{{ item.value }}</div>
          </a-card-grid>
        </a-card>
      </a-col>

      <a-col :md="24" :sm="8">
        <a-card :title="$t('dashboard.order.recipientInformation')">
          <a-card-grid
              v-for="(item, index) in orderUserInfor"
              :key="index"
              style="width:25%;height:92px;overflow:overlay;text-align:center"
          >
            <div>{{ item.label }}</div>
            <div>{{ item.value }}</div>
          </a-card-grid>
        </a-card>
      </a-col>

      <a-col :md="24" :sm="8">
        <a-card :title="$t('dashboard.order.cargoInformation')">
          <a-card-grid
              v-for="(item, index) in orderItInfor"
              :key="index"
              style="width:25%;height:92px;overflow:overlay;text-align:center"
          >
            <div>{{ item.label }}</div>
            <div>{{ item.value }}</div>
          </a-card-grid>
        </a-card>
      </a-col>

      <a-col :md="24" :sm="6">
        <a-card :title="$t('dashboard.order.orderTrack')">
          <!--          <a-skeleton active :paragraph="{ rows: 5 }" v-if="!orderTrack.length"/>-->
          <!--          <a-timeline v-else>-->
          <!--            <a-timeline-item v-for="(item, index) in orderTrack" :key="index">-->
          <!--              <h3>{{ item.eventType }}</h3>-->
          <!--              <div>{{ item.eventDetails }}</div>-->
          <!--              <div>{{ item.createTime }}</div>-->
          <!--            </a-timeline-item>-->
          <!--          </a-timeline>-->
          <a-skeleton active :paragraph="{ rows: 5 }" v-if="orderTrackLoading"/>
          <template>
            <a-empty v-if="!orderTrack.length" />
            <a-timeline v-else>
              <a-timeline-item v-for="(item, index) in orderTrack" :key="index">
                <h3>{{ item.eventType }}</h3>
                <div>{{ item.eventDetails }}</div>
                <div>{{ item.createTime }}</div>
              </a-timeline-item>
            </a-timeline>
          </template>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { orderTrack } from 'api/app'

export default {
  props: {
    inforData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    dictEum: {
      type: Object,
      required: true,
      default: () => ({})
    },
    dictSettlemenTypeEum: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },

  mounted() {
    this.formatInforData()
    this.getTrackData(this.inforData.id)
  },

  methods: {
    getTrackData(id) {
      orderTrack({ id }).then(res => {
        if (res.code == '200') {
          this.orderTrack = res.data
        } else {
          this.$message.error(res.msg)
        }
        this.orderTrackLoading = false
      })
    },

    formatInforData() {
      if (this.inforData) {
        this.orderInfo = this.orderInfo.map(item => {
          if (item.value == 'orderStatus') {
            return {
              label: item.label,
              value: this.dictEum[this.inforData[item.value] + ''] ? this.dictEum[this.inforData[item.value] + ''] : '',
            }
          } else if(item.value == 'settlemenType') {
            return {
              label: item.label,
              value: this.dictSettlemenTypeEum[this.inforData[item.value] + ''] ? this.dictSettlemenTypeEum[this.inforData[item.value] + ''] : '',
            }
          } else {
            return {
              label: item.label,
              value: this.inforData[item.value] ? this.inforData[item.value] : '',
            }
          }
        })

        this.orderUserInfor = this.orderUserInfor.map(item => ({
          label: item.label,
          value: this.inforData[item.value] ? this.inforData[item.value] : '',
        }))

        this.orderItInfor = this.orderItInfor.map(item => ({
          label: item.label,
          value: this.inforData[item.value] ? this.inforData[item.value] : '',
        }))

        console.warn(this.orderInfo, this.orderUserInfor, this.orderItInfor)
      }
    }
  },

  data() {
    return {
      orderTrack: [],
      orderTrackLoading: true,
      // 详情数据
      orderInfo: [
        {
          label: this.$t('dashboard.order.barCodeNo'),
          value: 'barCodeNo'
        },
        {
          label: this.$t('dashboard.order.dispatchPartition'),
          value: 'dispatchPartition'
        },
        {
          label: this.$t('dashboard.order.orderStatus'),
          value: 'orderStatus'
        },
        {
          label: this.$t('dashboard.order.serviceCode'),
          value: 'serviceType'
        },
        {
          label: this.$t('dashboard.order.libraryLocation'),
          value: 'shelfCode'
        },
        {
          label: this.$t('dashboard.order.inboundTime'),
          value: 'outboundTime'
        },
        {
          label: this.$t('dashboard.order.outboundTime'),
          value: 'outboundTime'
        },
        {
          label: this.$t('dashboard.order.siteName'),
          value: 'siteName'
        },{
          label: this.$t('dashboard.order.settlemenType'),
          value: 'settlemenType'
        },{
          label: this.$t('dashboard.order.amount'),
          value: 'amount'
        },{
          label: this.$t('dashboard.order.payAmount'),
          value: 'payAmount'
        },{
          label: this.$t('dashboard.order.discountAmount'),
          value: 'discountAmount'
        },{
          label: this.$t('dashboard.order.pointsDiscountAmount'),
          value: 'pointsDiscountAmount'
        },{
          label: this.$t('dashboard.order.currency'),
          value: 'currency'
        },{
          label: this.$t('dashboard.order.waybillNumber'),
          value: 'waybillNumber'
        },{
          label: this.$t('dashboard.order.productCode'),
          value: 'productCode'
        },{
          label: this.$t('dashboard.order.settlementCode'),
          value: 'settlementCode'
        },{
          label: this.$t('dashboard.order.mainMailCode'),
          value: 'mainMailCode'
        },{
          label: this.$t('dashboard.order.sumBoxNum'),
          value: 'sumBoxNum'
        },{
          label: this.$t('dashboard.order.paymentTime'),
          value: 'paymentTime'
        },{
          label: this.$t('dashboard.order.paymentSource'),
          value: 'paymentSource'
        }
      ],
      orderUserInfor: [
        {
          label: this.$t('dashboard.order.recipientDddress'),
          value: 'toCustAddress'
        },
        {
          label: this.$t('dashboard.order.addresseeProvince'),
          value: 'toCustCanton'
        },
        {
          label: this.$t('dashboard.order.recipientCity'),
          value: 'toCustCity'
        },
        {
          label: this.$t('dashboard.order.addresseeName'),
          value: 'toCustLinkman'
        },
        {
          label: this.$t('dashboard.order.recipientId'),
          value: 'toCustIdCardNo'
        },
        {
          label: this.$t('dashboard.order.recipientEmail'),
          value: 'toCustMail'
        },
        {
          label: this.$t('dashboard.order.recipientPostcode'),
          value: 'toCustZipCode'
        },
        {
          label: this.$t('dashboard.order.recipientTax'),
          value: 'toCustTaxNo'
        },
        {
          label: this.$t('dashboard.order.recipientPhone'),
          value: 'toCustTel'
        }
      ],
      orderItInfor: [
        {
          label: this.$t('dashboard.order.parcelWeight'),
          value: 'whtFactWht'
        },
        {
          label: this.$t('dashboard.order.high'),
          value: 'whtHeight'
        },
        {
          label: this.$t('dashboard.order.long'),
          value: 'whtLength'
        },
        {
          label: this.$t('dashboard.order.wide'),
          value: 'whtWidth'
        }
      ]
    }
  }
}
</script>

<style lang="less"></style>
